import { h } from "preact";

import { classNames } from "../helpers";

export default function LinearLoadingIndicator(props) {
  const style =
    props.progress !== undefined && props.progress !== null
      ? `width: ${props.progress}%`
      : null;

  return (
    <div
      class={classNames(
        "progress linear-loading-indicator",
        props.dark && "linear-loading-indicator--dark",
        props.jadeGrey && "linear-loading-indicator--jade-grey",
        props.class
      )}
    >
      {style ? (
        <div class="determinate" style={style}></div>
      ) : (
        <div class="indeterminate"></div>
      )}
    </div>
  );
}
